import { useRef } from 'react';
export default function useObjectKeysMemoize(deps) {
  const ref = useRef();
  if (!deps) {
    return deps;
  }
  if (!ref.current) {
    ref.current = deps;
  } else if (!keysEqual(deps, ref.current)) {
    ref.current = deps;
  }
  return ref.current;
}
function keysEqual(newValue, currentValue) {
  const newValueKeys = Object.keys(newValue);
  const currentValueKeys = Object.keys(currentValue);
  if (newValueKeys.length !== currentValueKeys.length) {
    return false;
  }
  return newValueKeys.every(key => {
    return newValue[key] === currentValue[key];
  });
}